export interface Video {
  id: string;
  slug: string;
  title: string;
  category: string;
  thumbnail: string;
  duration: string;
  views: number;
  rating: number;
  description: string;
  publishDate: string;
  tags: string[];
  director?: string;
  actors?: string[];
  region?: string;
  year?: string;
}

export const featuredVideos: Video[] = [
  {
    id: 'v001',
    slug: 'liulang-diqiu-3',
    title: '流浪地球3',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dramatic%20sci-fi%20movie%20poster%20style%20image%20showing%20a%20massive%20planet%20engine%20against%20a%20dark%20cosmic%20backdrop%20with%20warm%20orange%20and%20golden%20nebula%20lighting%2C%20cinematic%20composition%2C%20epic%20scale%2C%20clean%20background&width=640&height=360&seq=video-thumb-001&orientation=landscape',
    duration: '02:28:15',
    views: 8920000,
    rating: 9.2,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。',
    publishDate: '2026-07-15',
    tags: ['科幻', '灾难', '国产大片', '硬核科幻'],
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    region: '中国大陆',
    year: '2026',
  },
  {
    id: 'v002',
    slug: 'kuangbiao-2',
    title: '狂飙2：风云再起',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20tense%20crime%20drama%20TV%20series%20poster%20style%20image%20with%20two%20men%20in%20dark%20suits%20facing%20off%20under%20dramatic%20warm%20spotlight%2C%20modern%20urban%20night%20backdrop%2C%20cinematic%20lighting%2C%20clean%20composition&width=640&height=360&seq=video-thumb-002&orientation=landscape',
    duration: '45:30',
    views: 15600000,
    rating: 9.5,
    description: '扫黑除恶行动从未停止，新一轮的反腐风暴席卷临江省。安欣与高启强再次交锋，正义与邪恶的较量进入白热化阶段。',
    publishDate: '2026-08-01',
    tags: ['犯罪', '悬疑', '国产剧', '扫黑'],
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐'],
    region: '中国大陆',
    year: '2026',
  },
  {
    id: 'v003',
    slug: 'cheng-feng-po-lang-5',
    title: '乘风破浪的姐姐 第五季',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20glamorous%20variety%20show%20stage%20with%20sparkling%20golden%20lights%20and%20a%20group%20of%20elegant%20women%20on%20stage%2C%20warm%20spotlight%20illumination%2C%20entertainment%20show%20atmosphere%2C%20clean%20minimal%20background&width=640&height=360&seq=video-thumb-003&orientation=landscape',
    duration: '01:52:40',
    views: 23400000,
    rating: 8.9,
    description: '30位姐姐再次集结，用实力和魅力证明年龄只是数字。全新的赛制、更炸裂的舞台，谁将成为最终的C位？',
    publishDate: '2026-07-20',
    tags: ['综艺', '音乐', '女团', '真人秀'],
    region: '中国大陆',
    year: '2026',
  },
  {
    id: 'v004',
    slug: 'jianshi-juren-zuizhongji',
    title: '进击的巨人 最终季 完结篇',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20anime%20style%20artwork%20of%20a%20massive%20titan%20against%20a%20golden%20sunset%20sky%20with%20dramatic%20clouds%2C%20cinematic%20composition%2C%20warm%20atmospheric%20lighting%2C%20clean%20background&width=640&height=360&seq=video-thumb-004&orientation=landscape',
    duration: '01:25:00',
    views: 18900000,
    rating: 9.8,
    description: '艾伦发动地鸣，墙外的世界面临毁灭。三笠、阿尔敏等人必须做出最终抉择——拯救世界还是拯救艾伦？巨人的史诗终章震撼来袭。',
    publishDate: '2026-06-10',
    tags: ['动漫', '热血', '战斗', '日漫'],
    region: '日本',
    year: '2026',
  },
];

export const latestVideos: Video[] = [
  {
    id: 'v005',
    slug: 'yehaizhong-de-baochou',
    title: '夜海中的报酬',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20mysterious%20noir%20film%20poster%20with%20a%20solitary%20boat%20on%20dark%20water%20under%20moonlight%2C%20atmospheric%20fog%2C%20warm%20golden%20moon%20reflection%2C%20cinematic%20lighting%2C%20clean%20composition&width=640&height=360&seq=video-thumb-005&orientation=landscape',
    duration: '01:58:22',
    views: 3450000,
    rating: 8.7,
    description: '一个渔夫在深夜出海，意外卷入了一场涉及数百万现金的阴谋。',
    publishDate: '2026-08-05',
    tags: ['悬疑', '犯罪', '剧情'],
    director: '陈思诚',
    actors: ['朱一龙', '倪妮'],
    region: '中国大陆',
    year: '2026',
  },
  {
    id: 'v006',
    slug: 'mouxian-dangan-ludi',
    title: '冒险档案：海底秘境',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20underwater%20documentary%20scene%20with%20vibrant%20coral%20reef%20and%20sunlight%20rays%20piercing%20through%20crystal%20clear%20ocean%20water%2C%20warm%20aquatic%20tones%2C%20natural%20lighting%2C%20clean%20composition&width=640&height=360&seq=video-thumb-006&orientation=landscape',
    duration: '52:18',
    views: 2100000,
    rating: 9.1,
    description: '深入太平洋海底，探索从未被人类发现的深海秘境和神秘生物。',
    publishDate: '2026-08-04',
    tags: ['纪录片', '自然', '海洋', '探索'],
    region: '英国',
    year: '2026',
  },
  {
    id: 'v007',
    slug: 'shijie-diyi-chuji-5',
    title: '世界第一初季 第五季',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20teenage%20couple%20under%20cherry%20blossom%20trees%20with%20warm%20spring%20sunlight%2C%20romantic%20atmosphere%2C%20soft%20pastel%20warm%20tones%2C%20clean%20background&width=640&height=360&seq=video-thumb-007&orientation=landscape',
    duration: '24:30',
    views: 7800000,
    rating: 9.0,
    description: '新学期开始，初恋的酸甜故事继续上演。新角色加入，感情线更加错综复杂。',
    publishDate: '2026-08-03',
    tags: ['动漫', '恋爱', '校园', '日漫'],
    region: '日本',
    year: '2026',
  },
  {
    id: 'v008',
    slug: 'quanli-de-youxi-8',
    title: '权力的游戏 前传：龙之家族',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20majestic%20dragon%20silhouette%20against%20a%20burning%20golden%20sunset%20sky%20over%20a%20medieval%20castle%2C%20epic%20fantasy%20atmosphere%2C%20dramatic%20warm%20lighting%2C%20cinematic%20composition&width=640&height=360&seq=video-thumb-008&orientation=landscape',
    duration: '58:45',
    views: 12300000,
    rating: 9.3,
    description: '坦格利安家族的内战"血龙狂舞"全面爆发，龙与龙之间的史诗对决震撼上演。',
    publishDate: '2026-08-02',
    tags: ['美剧', '奇幻', '史诗', 'HBO'],
    region: '美国',
    year: '2026',
  },
  {
    id: 'v009',
    slug: 'zhongguo-xin-shuochang-3',
    title: '中国新说唱 第三季',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20vibrant%20hip-hop%20music%20stage%20with%20dynamic%20golden%20and%20red%20stage%20lighting%2C%20concert%20atmosphere%2C%20energetic%20performance%20vibe%2C%20clean%20dark%20background&width=640&height=360&seq=video-thumb-009&orientation=landscape',
    duration: '01:35:20',
    views: 6700000,
    rating: 8.5,
    description: '全新导师阵容，更激烈的赛制。全国最强Rapper齐聚，谁能问鼎冠军？',
    publishDate: '2026-08-01',
    tags: ['综艺', '音乐', '说唱', '选秀'],
    region: '中国大陆',
    year: '2026',
  },
  {
    id: 'v010',
    slug: 'NBA-zongjuesai-2026',
    title: 'NBA总决赛 2026 精彩集锦',
    category: 'tiyu',
    thumbnail: 'https://readdy.ai/api/search-image?query=An%20intense%20basketball%20game%20moment%20with%20a%20player%20dunking%20under%20bright%20arena%20spotlights%2C%20dynamic%20sports%20action%2C%20warm%20golden%20court%20lighting%2C%20dramatic%20composition&width=640&height=360&seq=video-thumb-010&orientation=landscape',
    duration: '15:42',
    views: 5600000,
    rating: 9.4,
    description: '2026年NBA总决赛七场大战全记录，绝杀、逆转、传奇时刻一网打尽。',
    publishDate: '2026-07-30',
    tags: ['体育', 'NBA', '篮球', '集锦'],
    region: '美国',
    year: '2026',
  },
  {
    id: 'v011',
    slug: 'shikong-lvxingzhe',
    title: '时空旅行者',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20film%20scene%20with%20a%20glowing%20time%20portal%20in%20a%20modern%20city%20street%2C%20warm%20golden%20light%20spilling%20from%20the%20portal%2C%20cinematic%20composition%2C%20mysterious%20atmosphere&width=640&height=360&seq=video-thumb-011&orientation=landscape',
    duration: '02:05:33',
    views: 4100000,
    rating: 8.8,
    description: '一个普通上班族意外获得穿越时空的能力，却发现每次穿越都会改变现实。',
    publishDate: '2026-07-28',
    tags: ['科幻', '剧情', '悬疑'],
    director: '韩寒',
    actors: ['沈腾', '刘浩存'],
    region: '中国大陆',
    year: '2026',
  },
  {
    id: 'v012',
    slug: 'meishi-tansuozhe',
    title: '美食探索者：川渝篇',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20beautiful%20close-up%20of%20steaming%20hot%20Sichuan%20cuisine%20on%20a%20wooden%20table%20with%20warm%20ambient%20restaurant%20lighting%2C%20appetizing%20red%20chili%20peppers%2C%20food%20documentary%20style&width=640&height=360&seq=video-thumb-012&orientation=landscape',
    duration: '48:20',
    views: 2900000,
    rating: 9.0,
    description: '深入重庆和四川，探寻最地道火锅、小面和江湖菜背后的美食故事。',
    publishDate: '2026-07-25',
    tags: ['纪录片', '美食', '川菜', '文化'],
    region: '中国大陆',
    year: '2026',
  },
];

export const allVideos = [...featuredVideos, ...latestVideos];

export const getVideosByCategory = (categorySlug: string): Video[] => {
  return allVideos.filter(v => v.category === categorySlug);
};

export const getVideoBySlug = (slug: string): Video | undefined => {
  return allVideos.find(v => v.slug === slug);
};

export const getRelatedVideos = (currentSlug: string, category: string, limit: number = 4): Video[] => {
  return allVideos.filter(v => v.slug !== currentSlug && v.category === category).slice(0, limit);
};